<template>
  <div class="ToggleButton" 
    @click="onSelected"> 
    <button class="btn btn-lg btn-block" :class="{'btn-info': value, 'btn-warning': !value}">
      <small v-if="!value"><i class="fa fa-exclamation-triangle"/> {{ label }}</small>
      <small v-else><i class="fa fa-check-circle"/> {{ labelSelected }}</small>
    </button>
  </div>
</template>
<script>
export default {
  name: 'ToggleButton',
  props: {
    value: { default: false },
    label: {},
    labelSelected: {}
  },
  methods: {
    onSelected() {
      this.$emit('input', !this.value)
    }
  }
}
</script>
<style lang="scss">
.ToggleButton {
  align-items: center;
  cursor: pointer;
  display: flex;
  user-select: none;

  .btn {
    white-space: normal;
    .fa {
      display: block;
    }
  }

  .check-box {
    background-color: white;
    border: 0.0625rem solid #cfd4da;
    border-radius: 0.32rem;
    margin-right: 0.4rem;
    padding: 0.42rem;
    height: 28px;
    width: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .label {
    font-size: 0.82rem;
    padding: 0.2rem;
  }
  .selected {
    background-color: #18a2b8;
    color: white;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Controls/ToggleButton.vue